import { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import logoColor from '../../assets/White Border Logo.png';
import logoWhite from '../../assets/logo-white.png';

export function Login() {
  const { signIn, profile } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const notice = location.state?.notice ?? '';

  useEffect(() => {
    if (profile) navigate(`/${profile.role}/dashboard`, { replace: true });
  }, [profile, navigate]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error } = await signIn(email, password);
    if (error) setError(error.message);
    setLoading(false);
  }

  return (
    <div className="auth-screen">
      <div className="auth-panel-left" style={{ position: 'relative', overflow: 'hidden' }}>
        <img
          src={logoWhite}
          alt=""
          aria-hidden="true"
          style={{
            position: 'absolute', top: '50%', left: '50%',
            transform: 'translate(-50%, -50%)',
            height: 480, opacity: 0.08, pointerEvents: 'none',
          }}
        />
        <div />
        <div>
          <p className="auth-panel-left-tagline">Training Platform</p>
          <h2 className="auth-panel-left-headline">Built for athletes<br />who compete.</h2>
        </div>
        <p className="auth-panel-left-footer">Apex Elite Training &copy; {new Date().getFullYear()}</p>
      </div>

      <div className="auth-panel-right">
        <div className="auth-card">
          <div className="auth-logo">
            <img src={logoColor} alt="Apex Elite" style={{ height: 40 }} />
          </div>
          <h1 className="auth-title">Sign in</h1>
          <p className="auth-subtitle">Welcome back — let's get to work.</p>

          <form className="form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input
                className="form-input"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <input
                className="form-input"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            {notice && <p style={{ color: 'var(--green, #16a34a)', fontSize: 13, marginBottom: 8 }}>{notice}</p>}
          {error && <p className="form-error">{error}</p>}
            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div className="auth-links">
            <Link to="/forgot-password" className="auth-link">Forgot password?</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
